import { TextArea } from "@itpi/react-components";
import React from "react";

interface JustifyProps {
  value: string;
  setText: Function;
  previousAnswer?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

export const Justify: React.FC<JustifyProps> = ({
  value,
  setText,
  previousAnswer,
  children,
  style,
}) => {
  const boxStyle = {
    paddingBottom: 30,
  };

  return (
    <div style={boxStyle}>
      <TextArea
        rows={3}
        placeholder={
          previousAnswer
            ? `Last time you said: \n ${previousAnswer}`
            : "Justify your self rating, using examples."
        }
        value={value}
        onChange={(e) => setText(e.target.value)}
      />
    </div>
  );
};
